module.exports = __webpack_public_path__ + "img/Blueberry_logo.db7e660c.svg";